import { render, staticRenderFns } from "./product-category-form-dialog.app.vue?vue&type=template&id=4233b335&"
import script from "./product-category-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./product-category-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports